// extracted by mini-css-extract-plugin
export var beginning = "styles-module--beginning--3356c";
export var beginningContainer = "styles-module--beginningContainer--ad728";
export var beginningContent = "styles-module--beginningContent--acd43";
export var closeBtn = "styles-module--closeBtn--2b5c5";